import { FormGroup } from '@angular/forms';

export class LicenseValidationFormWidgetJson {
  showValidLicenseFields = false;

  getWidgetJson(form: FormGroup, model: any) {
    return {
      valueChangesFunctions: {} as any,
      wrapperClass: 'row',
      questions: [
        {
          'type': 'text',
          'name': model?.jsonObj?.namesReplacements?.licenseName || 'LicName',
          'startWithNewLine': true,
          'title': model?.jsonObj?.labelsReplacements?.licenseName || 'Name on License',
          'isRequired': true,
          class: 'col-sm-12 col-md-4',
          formControl: form.get('license_name'),
          controlName: 'license_name',
          controlVisibleIf: this.shouldShowValidLicenseFields()
        },
        {
          'type': 'text',
          'name': model?.jsonObj?.namesReplacements?.licenseNumber || 'LicNumber',
          'startWithNewLine': false,
          'title': model?.jsonObj?.labelsReplacements?.licenseNumber || 'License Number',
          placeholder: model?.jsonObj?.placeholderReplacements?.licenseNumber  || undefined,
          mask: model?.jsonObj?.masksReplacements?.licenseNumber || undefined,
          description: model?.jsonObj?.descriptionsReplacements?.licenseNumber || undefined,
          'isRequired': true,
          class: 'col-sm-12 col-md-4',
          formControl: form.get('license_number'),
          controlName: 'license_number'
        },
        {
          'type': 'text',
          'name': model?.jsonObj?.namesReplacements?.licenseState || 'LicState',
          'startWithNewLine': false,
          'title': model?.jsonObj?.labelsReplacements?.licenseState || 'License State',
          'isRequired': true,
          class: 'col-sm-12 col-md-4',
          formControl: form.get('license_state'),
          controlName: 'license_state',
          controlVisibleIf: this.shouldShowValidLicenseFields()
        },
        {
          'type': 'text',
          'name': model?.jsonObj?.namesReplacements?.licenseType || 'LicType',
          'startWithNewLine': true,
          'title': model?.jsonObj?.labelsReplacements?.licenseType || 'License Type',
          'isRequired': true,
          class: 'col-sm-12 col-md-4',
          formControl: form.get('license_type'),
          controlName: 'license_type',
          controlVisibleIf: this.shouldShowValidLicenseFields()
        },
        {
          'type': 'text',
          'name': model?.jsonObj?.namesReplacements?.licenseStatus || 'LicStatus',
          'startWithNewLine': false,
          'title': model?.jsonObj?.labelsReplacements?.licenseStatus || 'License Status',
          'isRequired': true,
          class: 'col-sm-12 col-md-4',
          formControl: form.get('license_status'),
          controlName: 'license_status',
          controlVisibleIf: this.shouldShowValidLicenseFields()
        },
        {
          'type': 'text',
          'name': model?.jsonObj?.namesReplacements?.licenseExpiry || 'LicExp',
          'title': model?.jsonObj?.labelsReplacements?.licenseExpiry || 'License Expiry',
          'isRequired': true,
          class: 'col-sm-12 col-md-4',
          formControl: form.get('license_expiry'),
          controlName: 'license_expiry',
          controlVisibleIf: this.shouldShowValidLicenseFields()
        },
        {
          'type': 'text',
          'name': model?.jsonObj?.namesReplacements?.brokerLicenseName || 'BrkName',
          'title': model?.jsonObj?.labelsReplacements?.brokerLicenseName || 'Sponsoring Inspector',
          'isRequired': false,
          visible: false,
          formControl: form.get('broker_license_name'),
          controlName: 'broker_license_name',
        },
        {
          'type': 'text',
          'name': 'BrkLic',
          'startWithNewLine': false,
          'title': 'Sponsoring Inspector License Number',
          'isRequired': false,
          visible: false,
          formControl: form.get('broker_license_number'),
          controlName: 'broker_license_number',
        },
        {
          'type': 'text',
          'name': 'CorpLic',
          'startWithNewLine': false,
          'visible': false,
          'title': 'Corporate License Number',
          'isRequired': false,
          formControl: form.get('corporate_license_number'),
          controlName: 'corporate_license_number',
        },
        {
          'type': 'text',
          'name': 'BrkLicType',
          'startWithNewLine': false,
          'visible': false,
          'title': 'Broker License Type',
          'isRequired': false,
          formControl: form.get('broker_license_type'),
          controlName: 'broker_license_type',
        },
      ]
    };
  };

  shouldShowValidLicenseFields() {
    const that = this;

    return () => {
      return that.showValidLicenseFields;
    };
  }
}


/*'visibleIf': '{BrkLic} notempty';
'visibleIf': '{BrkName} notempty';*/
